import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    renderData: [],
    status: 'idle',
};

export const getAwards = createAsyncThunk('/awards/get', async () => {

    let res = axios.get('awards',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.Projects


    
})

export const createAward = createAsyncThunk('/awards/create', async (item) => {

    let res = axios.post('awards', item,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data, "suppoort post");
      if(data.data.success){
        alert("Yutuqlarga qo'shildi")
      }


    
})
// export const deleteCategory = createAsyncThunk('/categories/delete', async (item) => {

//     let res = axios.delete(`categories/${item.parent._id}`,{
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`
//         }
//       }).catch((err)=>{
//         console.log(err)
//         // setError(err.response.data.message)
//       })
      
      
//       const data = await res
//       console.log(data);
//       if(data.data.success){
//         alert("Kategoriya o'chirildi")
//       }


    
// })
const awards = createSlice({
    name: 'awards',
    initialState,
    reducers: {
      sortAwards(state, {payload}) {
        if(payload.role == "admin") {
          state.renderData = state.data
        } else {
          state.renderData = state.data.filter(item => item.user_id._id == payload.id)
        }
      }
    },
    extraReducers(builder) {
      builder
      .addCase(getAwards.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getAwards.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getAwards.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createAward.fulfilled, (state, action) => {
        state.status = 'idle'
      })
    //   .addCase(deleteCategory.fulfilled, (state, action) => {
    //     state.status = 'idle'
    //   })
      }
  });


  export  const {sortAwards} = awards.actions
export const reducer = awards.reducer;